﻿import * as types from './mutation-types';
import * as mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters'


const state = {
    alertModal: {
        show: false,
        active: false,
        icon: 'default',
        context: '',
        headline: '',
        message: '',
        buttons: [],
        refresh: false,
        digitalSignatureLabels: {
            name: 'Name',
            contracts: 'Contracts',
            sign: 'Sign'
        }
    },
    contracts: {
        contractsSigned: false,
        showDivaContracts: false,
        validEmails: false,
        divaContracts: '',
        signedPortings: '',
        simSaved: false,
        signingError: {
            message: '',
            show: false
        }
    },
    pageOverview:
    {
        orderNumber: '',
        customerNumber: '',
        customerName: '',
        cprNumber: '',
        address: '',
        email: '',
        contactNumber: ''
    },
    deliveryAddress:
    {
        type: '',
        fullName: '',
        addressStreet: '',
        addressCity: '',
        pickupPointName: ''
    },
    pageLoader: {
        showLoader: false,
        loaderTitle: 'Processing...',
        loaderMessage: 'Please do not close the browser window',
        loaderPreAuthTitle: 'Customer Look-up',
        loaderPreAuthMessage: 'We are verifying if customer is new or existing Telia Delbetalings customer',
        loaderCreditCheckTitle: 'Credit Evaluation',
        loaderCreditCheckMessage: 'Credit evaluation is being performed. Please wait.',
        loaderSubmitOrderTitle: 'ORDER IS BEING PROCESSED',
        loaderSubmitOrderMessage: 'Please do not close the browser window'
    },
    cancelation: {
        orderCanceled: false,
        showCancelOrderModal: false
    },
    form: [],
    partial : []
}

export default{
    state,
    getters,
    mutations,
    actions
}